/** @jsx jsx */
import { jsx } from "theme-ui"
import { graphql, useStaticQuery } from "gatsby"

import { Row, Col } from "components/layout"
import Card from "components/card"

import useLocales from "hooks/use-locales"

const DevelopmentGrid = () => {
  const { t } = useLocales()
  const data = useStaticQuery(graphql`
    query DevelopmentGridQuery {
      one: file(relativePath: { eq: "development-1.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 445) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      two: file(relativePath: { eq: "development-2.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 445) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      three: file(relativePath: { eq: "development-3.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 190) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      four: file(relativePath: { eq: "development-4.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 445) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      five: file(relativePath: { eq: "development-5.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 225) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <Row sx={{ flexWrap: "wrap", mx: -3 }}>
      <Col
        sx={{
          width: ["100%", "45%"],
          display: "flex",
          flexDirection: "column",
          mb: 3,
        }}
      >
        <Card
          fluid={data.one.childImageSharp.fluid}
          imgHeight={["500px", "350px"]}
        >
          {t("grid.development.1")}
        </Card>
      </Col>
      <Col
        sx={{
          width: ["50%", "45%"],
          display: "flex",
          flexDirection: "column",
          mb: 3,
        }}
      >
        <Card fluid={data.two.childImageSharp.fluid}>
          {t("grid.development.2")}
        </Card>
      </Col>
      <Col
        sx={{
          width: ["100%", "25%"],
          display: "flex",
          flexDirection: "column",
          mb: 3,
        }}
      >
        <Card fluid={data.three.childImageSharp.fluid}>
          {t("grid.development.3")}
        </Card>
      </Col>
      <Col
        sx={{
          width: ["100%", "35%"],
          display: "flex",
          flexDirection: "column",
          mb: 3,
        }}
      >
        <Card fluid={data.four.childImageSharp.fluid}>
          {t("grid.development.4")}
        </Card>
      </Col>
      <Col
        sx={{
          width: ["100%", "30%"],
          display: "flex",
          flexDirection: "column",
          mb: 3,
        }}
      >
        <Card fluid={data.five.childImageSharp.fluid}>
          {t("grid.development.5")}
        </Card>
      </Col>
    </Row>
  )
}

export default DevelopmentGrid
